export const black = {
  black1: "#000",
  black2: "#110D03",
  black3: "#141414",
  black4: "#010402",
};
